<template>
  <van-overlay :show="show" @click="cancel" :z-index="102">
    <div class="popup_box">
      <div class="popup">
        <div @click="() => cancel()" class="popup_close close_center"><span></span></div>
        <div class="title">{{ $t('envelope.congratulation') }}</div>
        <div class="amount">
          {{ reward ? formatMoney(reward.totalReward) : '--' }}
          {{ unitConversion(balance.currencyAlias) }}
        </div>
        <div class="tips">{{ $t('envelope.checkit') }}</div>
        <div class="button" @click="onGetNewBox">{{ $t('envelope.getnew') }}</div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { useEnvelopeStore } from '@/stores/envelope'
import { useUserStore } from '@/stores/user'
import { formatMoney, unitConversion } from '@/utils/helper'
import { mapState } from 'pinia'
export default {
  name: 'LobbyActiveProgressPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    openNewBox: {
      type: Function,
      default: () => console.log('updateData:::envelopeBox')
    }
  },
  computed: {
    ...mapState(useEnvelopeStore, ['reward']),
    ...mapState(useUserStore, ['userInfo', 'balance', 'isLogin'])
  },

  methods: {
    formatMoney,
    unitConversion,
    onGetNewBox() {
      this.cancel()
      this.openNewBox()
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .close_center {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    text-align: center;
    z-index: 2;
    margin-left: 90%;
    margin-top: -5%;
    margin-bottom: -0.8rem;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(-90deg);
    }
  }

  .popup {
    width: 5rem;
    height: auto;
    background: #f1f1f1;
    border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
    border: 0.02rem solid #95a5a5;
    padding: 0.3rem;

    .title {
      width: 100%;
      height: 0.25rem;
      font-family: DroidSans;
      font-weight: bold;
      font-size: 0.3rem;
      color: #000000;
      line-height: 0.3rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 0.55rem;
    }

    .amount {
      width: 100%;
      height: 0.51rem;
      font-family: Oswald;
      font-weight: bold;
      font-size: 0.5rem;
      color: #009944;
      line-height: 0.4rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 0.3rem;
    }

    .tips {
      width: 100%;
      height: 0.25rem;
      font-family: DroidSans;
      font-size: 0.24rem;
      color: #009944;
      line-height: 0.4rem;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 4.4rem;
      height: 0.7rem;
      background: #336aea;
      border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;

      font-family: DroidSans;
      font-size: 0.24rem;
      color: #ffffff;
      line-height: 0.24rem;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-left: 0.3rem;
      margin-top: 0.5rem;
    }
  }
}
</style>
